export default "__VITE_ASSET__D3h2Pxai__"